const getFormattedENumber = (eNumber) => {
  if (eNumber) {
    if (eNumber.charAt(0) === 'E') {
      return eNumber.substring(1)
    } else {
      return eNumber
    }
  } else {
    return null
  }
}

export default getFormattedENumber
